module.exports = __webpack_public_path__ + "img/28.549c159b.jpg";